var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 10.5142 2 13.1046 2.87868 13.8856C3.75736 14.6667 5.17157 14.6667 8 14.6667C10.8284 14.6667 12.2426 14.6667 13.1213 13.8856C14 13.1046 14 10.5142 14 8",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77359 9.46794L13.9053 8.22841C14.1793 8.14624 14.3162 8.10515 14.4176 8.02366C14.5062 7.9525 14.5751 7.85989 14.6178 7.75462C14.6667 7.63407 14.6667 7.49108 14.6667 7.2051C14.6667 6.08018 14.6667 5.51772 14.4469 5.08845C14.2556 4.71495 13.9518 4.41106 13.5783 4.21981C13.149 4 12.5865 4 11.4616 4H4.53848C3.41356 4 2.8511 4 2.42182 4.21981C2.04832 4.41106 1.74444 4.71495 1.55318 5.08845C1.33337 5.51772 1.33337 6.08018 1.33337 7.2051C1.33337 7.49108 1.33337 7.63407 1.38228 7.75462C1.425 7.85989 1.4939 7.9525 1.58246 8.02366C1.68387 8.10515 1.82083 8.14624 2.09475 8.22841L6.22649 9.46794",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 8.33337H6.66671C6.48261 8.33337 6.33337 8.48261 6.33337 8.66671V10.1077C6.33337 10.244 6.41636 10.3666 6.54291 10.4172L7.00967 10.6039C7.64543 10.8582 8.35465 10.8582 8.99042 10.6039L9.45717 10.4172C9.58372 10.3666 9.66671 10.244 9.66671 10.1077V8.66671C9.66671 8.48261 9.51747 8.33337 9.33337 8.33337Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11389 2.66671C6.38845 1.88991 7.12928 1.33337 8.00009 1.33337C8.8709 1.33337 9.61173 1.88991 9.88628 2.66671",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupation);
export default __webpack_public_path__ + "static/media/occupation.e3b66dc0990dd39bb764ac71ec88fca5.svg";
export { ForwardRef as ReactComponent };